import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { UserCertificationModel } from '@models/user-certification-model';
import { MatDialog } from '@angular/material';
import { ContestCertificationPopupComponent } from '../contest-certification-popup/contest-certification-popup.component';
import { ReceiveCertificationPopupComponent } from '../receive-certification-popup/receive-certification-popup.component';
import { CertificationStatus } from '@models/certification-status';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-certification-widget',
  templateUrl: './certification-widget.component.html',
  styleUrls: ['./certification-widget.component.scss']
})
export class CertificationWidgetComponent implements OnInit, OnChanges {
  @Input() certification: UserCertificationModel;
  @Input() isLast = false;
  isCompleted = false;
  CertificationStatus = CertificationStatus;
  pdfLocale = 'EN';

  constructor(public dialog: MatDialog, private translateService: TranslateService) {}

  ngOnInit() {
    this.translateService.onLangChange.subscribe(event => {
      this.pdfLocale = event.lang.indexOf('fr') !== -1 ? 'FR' : 'EN';
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('certification' in changes) {
      this.isCompleted = this.certification.status === CertificationStatus.Completed;
    }
  }

  openContestDialog(certificationNumber: string): void {
    this.dialog.open(ContestCertificationPopupComponent, {
      data: { number: certificationNumber }
    });
  }

  openReceiveDialog(): void {
    this.dialog.open(ReceiveCertificationPopupComponent);
  }
}
